export { default } from './DestacatMapaAnimat';
